import { LayoutDashboard } from "lucide-react";

import type { TIconProps } from "./types";

// NOTE: NSAI-5657 — the sidebar glyph for saved dashboards. Not the admin
// panel's `AdminDashboard`: that one names the admin overview, this one the
// user's own pages.
export const Dashboards = (props: TIconProps): JSX.Element => (
  <LayoutDashboard
    stroke="var(--fill1)"
    style={{ strokeWidth: "calc(1.5 + var(--nav-glyph-bold, 0) * 1.2)" }}
    {...props}
  />
);
